import { Injectable } from "@angular/core";
import { InterpreterService } from "./interpreter.service";
import { XLogoSyntaxError, XLogoSemanticError } from "app/xlogo-parser";

// #########################################################################
//
// This service is used to shake html elements to indicate errors more visually
//
// #########################################################################

@Injectable()
export class ShakerService {
  constructor(private interpreterService: InterpreterService) {
    this.interpreterService.registerEventListenerStarted(
      this.onInterpreterStart.bind(this)
    );
  }

  private onInterpreterStart(
    input: string,
    started_successfully: boolean,
    syntaxError: XLogoSyntaxError[],
    semanticError: XLogoSemanticError[]
  ) {
    if (!started_successfully) {
      this.shake(document.getElementById("container"));
    }
  }

  private shakingElements = [];

  public shake(element, magnitude = 2, angular = true) {
    //First set the initial tilt angle to the right (+1)
    var tiltAngle = 1;

    //A counter to count the number of shakes
    var counter = 1;

    //The total number of shakes (there will be 1 shake per frame)
    var numberOfShakes = 10;

    //Capture the element's position and angle so you can
    //restore them after the shaking has finished
    var startX = 0,
      startY = 0,
      startAngle = 0;

    // Divide the magnitude into 10 units so that you can
    // reduce the amount of shake by 10 percent each frame
    var magnitudeUnit = magnitude / numberOfShakes;

    //The `randomInt` helper function
    var randomInt = (min, max) => {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    };

    //Add the element to the `shakingElements` array if it
    //isn't already there
    if (this.shakingElements.indexOf(element) === -1) {
      this.shakingElements.push(element);

      //Add an `updateShake` method to the element.
      //The `updateShake` method will be called each frame
      //in the game loop.
      angularShake(this.shakingElements);
    }

    //The `angularShake` function
    function angularShake(shakingElements) {
      if (counter < numberOfShakes) {
        //Reset the element's rotation
        element.style.transform = "rotate(" + startAngle + "deg)";

        //Reduce the magnitude
        magnitude -= magnitudeUnit;

        //Rotate the element left or right, depending on the direction,
        //by an amount in radians that matches the magnitude
        var angle = Number(magnitude * tiltAngle).toFixed(2);
        element.style.transform = "rotate(" + angle + "deg)";
        counter += 1;

        //Reverse the tilt angle so that the element is tilted
        //in the opposite direction for the next shake
        tiltAngle *= -1;

        requestAnimationFrame(
          function() {
            angularShake(shakingElements);
          }.bind(this)
        );
      }

      //When the shaking is finished, reset the element's angle and
      //remove it from the `shakingElements` array
      if (counter >= numberOfShakes) {
        element.style.transform = "rotate(" + startAngle + "deg)";
        shakingElements.splice(shakingElements.indexOf(element), 1);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/shaker.service.ts